import { Card, CardContent, Divider, Grid, Menu, MenuItem, Typography } from "@mui/material";
import { withStyles, WithStyles } from "@mui/styles";
import { FeedStyleClasses, GlobalClassKeys } from "assets/jss/common-styles";
import ButtonCardAction from "components/Buttons/ButtonCardAction";
import ButtonEllipsis from "components/Buttons/ButtonEllipsis";
import IconButtonEdit from "components/Buttons/IconButtonEdit";
import IconAddPeople from "components/Icons/IconAddPeople";
import IconDashboard from "components/Icons/IconDashboard";
import IconEdit from "components/Icons/IconEdit";
import IconEnrollments from "components/Icons/IconEnrollments";
import IconSocialComments from "components/Icons/IconSocialComments";
import IconSocialLikes from "components/Icons/IconSocialLikes";
import IconTrophy from "components/Icons/IconTrophy";
import { JoinComponents } from "components/JoinComponents";
import MuiRegularButton from "components/MuiExtras/Button/MuiRegularButton";
import MuiClickable from "components/MuiExtras/MuiClickable";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiLink from "components/MuiExtras/MuiLink";
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import MuiReverse from "components/MuiExtras/Typography/MuiReverse";
import { withSnackbar, WithSnackbar } from "components/SnackbarProvider/Snackbar";
import HtmlUtils from "lib/HtmlUtils";
import { PublicationAdminCourseDto, TopicSuggestionDto } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { RoutePaths } from "routes/RouteConfig";
import CourseAdminBody from "views/Publication/Components/CourseAdminBody";
import CourseAdminInlineTopicEdit from "views/Publication/Components/CourseAdminInlineTopicEdit";
import CourseAdminDashboardDialog from "views/Publication/Dialogs/CourseAdminDashboardDialog";
import CourseEnrollDrawer from "views/Publication/Dialogs/CourseEnrollDrawer";
import CourseEnrollReviewDrawer from "views/Publication/Dialogs/CourseEnrollReviewDrawer";
import CourseWhoCanEnrollDrawer from "views/Publication/Dialogs/CourseWhoCanEnrollDrawer";
import PublicationCommentsDialog from "views/Publication/Dialogs/PublicationCommentsDialog";
import PublicationLogDialog from "views/Publication/Dialogs/PublicationLogDialog";
import { TopicsLine } from "views/Timeline/Components/CardComp/TopicsLine";
import PublicationLikesReviewDrawer from "views/Timeline/Dialogs/PublicationLikesReviewDrawer";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    mouseOver: boolean;
    menuAnchorEl: any;
    dialog: any;
}

export interface IProps {
    item: PublicationAdminCourseDto;
    fullView: boolean;
    allowManageEnroll: boolean;
    onEdit?: (publicationId: string) => void;
    onDelete?: (publicationId: string, enrollments: number) => void;
    onUpdateTopics?: (topics: TopicSuggestionDto[]) => void;
    onExpand: (item: PublicationAdminCourseDto, expanded: boolean) => void;
    onNeedReload: () => void;
}

type Props = IProps & WithSnackbar & WithTranslation & WithStyles<typeof FeedStyleClasses>;

/////////////////////////////////////////////////////////////////////////////////////

class CourseAdminCard extends React.Component<Props, IState> {

    constructor(props: Props) {
        super(props);

        this.state = {
            dialog: null,
            mouseOver: false,
            menuAnchorEl: null
        };
    }

    ///
    private handleCloseMenu() {
        this.setState({ menuAnchorEl: null, mouseOver: false });
    }

    ///
    private handleEnrollReview = () => {
        this.setState({
            menuAnchorEl: null,
            mouseOver: false,
            dialog: <CourseEnrollReviewDrawer
                allowManageEnroll={ this.props.allowManageEnroll}
                courseId={this.props.item.publicationId}
                onClose={(changed) => this.setState({ dialog: null }, () => changed && this.props.onNeedReload())}
            />
        });
    };


    private handleLikeReview = () => {
        this.setState({
            dialog: <PublicationLikesReviewDrawer
                publicationId={this.props.item.publicationId}
                onClose={() => this.setState({ dialog: null })}
            />
        });
    };


    private handlCommentsReview = () => {
        this.setState({
            dialog: <PublicationCommentsDialog
                publicationId={this.props.item.publicationId}
                onClose={() => this.setState({ dialog: null })}
            />
        });
    };

    ///
    private handleWhoCanView = () => {
        this.setState({
            menuAnchorEl: null,
            mouseOver: false,
            dialog: <CourseWhoCanEnrollDrawer
                courseId={this.props.item.publicationId}
                onClose={() => this.setState({ dialog: null })}
            />
        });
    };

    ///
    private handleAudit = () => {
        this.setState({
            menuAnchorEl: null,
            mouseOver: false,
            dialog: <PublicationLogDialog
                publicationId={this.props.item.publicationId}
                onClose={() => this.setState({ dialog: null })}
            />
        });
    };

    ///
    private handleEdit = () => {
        const { item: { publicationId } } = this.props;

        this.setState({
            mouseOver: false,
            menuAnchorEl: null,
        });

        this.props.onEdit(publicationId);
    };

    ///
    private handleDelete = () => {
        const { item: { publicationId, statistics } } = this.props;

        this.setState({
            mouseOver: false,
            menuAnchorEl: null,
        });

        this.props.onDelete(publicationId, statistics.enrollments);
    };

    ///
    private handleDashboard = (item: PublicationAdminCourseDto) => {
        this.setState({
            dialog: <CourseAdminDashboardDialog
                course={item}
                onClose={() => this.setState({ dialog: null })}
            />
        });
    };

    ///
    private handleEnroll = (item: PublicationAdminCourseDto) => {
        this.setState({
            dialog: (
                <CourseEnrollDrawer
                    course={item}
                    onClose={
                        (count) => {
                            if (count != null && count > 0) {
                                this.setState((state) => {
                                    item.statistics.enrollments += count;
                                    return { ...state, dialog: null };
                                });
                            }
                            else
                                this.setState({ dialog: null });
                        }
                    }
                />
            )
        });
    };

    ///
    private buildOverflowMenu() {

        const {
            item: {
                permissions: {
                    canEdit,
                    canDelete,
                },
                autoEnroll,
            },
            fullView,
            onEdit,
            onDelete
        } = this.props;

        const actionMenu: React.ReactNode[] = [];

        if (autoEnroll == true) {
            actionMenu.push(<MenuItem key="whoCanView" onClick={() => this.handleWhoCanView()}>{this.props.t("Common.MenuAction.WhoCanEnroll")}</MenuItem>);
        }

        if (actionMenu.length > 0) actionMenu.push(<Divider key="divAudit" />);
        actionMenu.push(<MenuItem key="audit" onClick={this.handleAudit}>{this.props.t("Common.MenuAction.Audit")}</MenuItem>);

        if (canEdit || canDelete) {
            if (actionMenu.length > 0) actionMenu.push(<Divider key="dividerEdit" />);

            if (canEdit && onEdit && !fullView) {
                actionMenu.push(<MenuItem key="edit" onClick={() => this.handleEdit()}>{this.props.t("Common.MenuAction.Edit")}</MenuItem>);
            }

            if (canDelete && onDelete) {
                actionMenu.push(<MenuItem key="delete" onClick={() => this.handleDelete()}><MuiColor variant="error">{this.props.t("Common.MenuAction.Delete")}</MuiColor></MenuItem>);
            }
        }

        return (
            <>
                <ButtonEllipsis
                    onClick={(e) => { this.setState({ menuAnchorEl: e.currentTarget }); }}
                />
                <Menu
                    open={this.state.menuAnchorEl != null}
                    anchorEl={this.state.menuAnchorEl}
                    onClose={() => { this.handleCloseMenu(); }}
                >
                    {actionMenu}
                </Menu>
            </>
        );
    }

    ///
    private getSubtitle() {

        const {
            item: {
                viewPeriodStart,
                viewPeriodEnd,
                expired,
                gainPoints
            }
        } = this.props;

        const subtitle: React.ReactNode[] = [];

        if (expired) {
            subtitle.push(<MuiColor variant="muted">{this.props.t("Common.Feed.Course.CourseExpired")}</MuiColor>);
        }
        else {
            if (gainPoints > 0)
                subtitle.push(
                    <MuiColor variant="muted">
                        <IconTrophy />
                        <span>&nbsp;{gainPoints}</span>
                    </MuiColor>
                );

            if (viewPeriodStart != null && viewPeriodEnd == null)
                subtitle.push(<MuiColor variant="muted">{this.props.t("Common.Feed.Course.CourseAvailableFrom", { startDate: viewPeriodStart })}</MuiColor>);
            else if (viewPeriodStart == null && viewPeriodEnd != null)
                subtitle.push(<MuiColor variant="muted">{this.props.t("Common.Feed.Course.CourseAvailableUntil", { endDate: viewPeriodEnd })}</MuiColor>);
            else if (viewPeriodStart != null && viewPeriodEnd != null)
                subtitle.push(<MuiColor variant="muted">{this.props.t("Common.Feed.Course.CoursePeriod", { startDate: viewPeriodStart, endDate: viewPeriodEnd })}</MuiColor>);
        }

        return subtitle;
    }

    ///
    private getStatus() {
        const {
            fullView,
            item: { mustBePublished, numberOfItems }
        } = this.props;

        return !fullView && (mustBePublished === true || numberOfItems === 0)
            ? < MuiReverse color="warning" > {this.props.t("Common.Feed.Course.CourseNotPublished")}</MuiReverse >
            : null;
    }

    ///
    private renderRightActions() {
        const {
            item,
        } = this.props;

        return (
            <Grid container spacing={1} alignItems="baseline">
                {
                    item.publishDate != null &&
                    <Grid item>
                        <MuiRegularButton
                            simple
                            title={this.props.t("Common.Feed.Actions.ButtonEnrollPeopleTitle")}
                            color="transparent"
                            onClick={() => this.handleEnroll(item)}
                        >
                            <IconAddPeople />
                        </MuiRegularButton>
                    </Grid>
                }
                <Grid item>
                    <MuiRegularButton
                        simple
                        title="Dashboard"
                        color="transparent"
                        onClick={() => this.handleDashboard(item)}
                    >
                        <IconDashboard />
                    </MuiRegularButton>
                </Grid>

                <Grid item>
                    {this.buildOverflowMenu()}
                </Grid>
            </Grid>
        );
    }

    ///
    public render() {
        const {
            classes,
            fullView,
            item,
            onEdit,
        } = this.props;

        const {
            title,
            statistics,
            body,
            topics,
            expired,
            permissions: { canEdit }
        } = item;

        const {
            mouseOver
        } = this.state;

        const subtitle = this.getSubtitle();
        const handleEdit = onEdit ? this.handleEdit : null;

        return (
            <>
                {this.state.dialog}

                <Card
                    className={classes.card}
                    onMouseEnter={() => this.setState({ mouseOver: true })}
                    onMouseLeave={() => this.setState({ mouseOver: false })}
                >
                    <CardContent className={classes.cardContent}>

                        <MuiContainer margin="dense">
                            <Grid container>
                                <Grid item xs>
                                    {
                                        fullView && item.permissions.canEdit
                                            ? (
                                                <CourseAdminInlineTopicEdit
                                                    classes={classes}
                                                    data={item}
                                                    mouseOver={mouseOver}
                                                    onTopicClick={(id) => HtmlUtils.openUrlInNewWindow(RoutePaths.TopicViewer.replace(":id", id))}
                                                    onUpdateCard={(topics) => this.props.onUpdateTopics(topics)}
                                                />
                                            )
                                            : <TopicsLine
                                                topics={topics}
                                                onTopicClick={(id) => HtmlUtils.openUrlInNewWindow(RoutePaths.TopicViewer.replace(":id", id))}
                                            />
                                    }
                                </Grid>
                                {
                                    !fullView &&
                                    <Grid item>
                                        <Grid item className={classes.cardActions}>
                                            <IconButtonEdit visible={mouseOver && canEdit} onClick={handleEdit} size="small" />
                                        </Grid>
                                    </Grid>
                                }
                            </Grid>
                        </MuiContainer>

                        <MuiContainer margin="dense" className={classes.titleContainer}>
                            {
                                <MuiLink onClick={handleEdit}  >
                                    <Typography variant="h5">
                                        <MuiColor variant={expired ? "warning" : "inherit"}>
                                            {title}
                                        </MuiColor>
                                    </Typography>
                                </MuiLink>
                            }
                            <Grid container justifyContent="space-between" alignItems="center">
                                <Grid item xs>
                                    {
                                        subtitle.length > 0 &&
                                        <Typography variant="subtitle2" color="inherit">
                                            <JoinComponents components={subtitle} separator="&nbsp;&bull;&nbsp;" />
                                        </Typography>
                                    }
                                </Grid>
                                <Grid item className={GlobalClassKeys.textRight} >
                                    {this.getStatus()}
                                </Grid>
                            </Grid>
                        </MuiContainer>

                        {
                            body &&
                            <MuiContainer margin="normal">
                                <CourseAdminBody
                                    data={item}
                                    classes={this.props.classes}
                                    showPublisher={false}
                                    onTextExpandedChange={(textExpanded) => this.props.onExpand(this.props.item, textExpanded)}
                                />
                            </MuiContainer>
                        }

                        <div className={this.props.classes.cardActions}>
                            {
                                fullView && onEdit && canEdit &&
                                <Grid container spacing={1} justifyContent={"space-between"} alignItems="baseline">
                                    <Grid item>
                                        <MuiClickable onClick={this.handleEdit}>
                                            <MuiMuted>
                                                <IconEdit />
                                                <span>&nbsp;{this.props.t("Views.Publication.Components.CourseAdminCard.ButtonEditCourseText")}</span>
                                            </MuiMuted>
                                        </MuiClickable>
                                    </Grid>
                                    <Grid item className={classes.cardActions}>
                                        {this.renderRightActions()}
                                    </Grid>
                                </Grid>
                            }

                            {
                                !fullView &&
                                <Grid container spacing={1} justifyContent={"space-between"} alignItems="baseline">
                                    <Grid item>
                                        <ButtonCardAction
                                            title={this.props.t("Common.Feed.Actions.ButtonEnrolledTitle")}
                                            onClick={this.handleEnrollReview}
                                        >
                                            <IconEnrollments />
                                            <span>&nbsp;{statistics.enrollments}</span>
                                        </ButtonCardAction>
                                    </Grid>

                                    <Grid item>
                                        <ButtonCardAction
                                            title={this.props.t("Common.Feed.Actions.ButtonLikedTitle")}
                                            onClick={this.handleLikeReview}
                                        >
                                            <IconSocialLikes />
                                            <span>&nbsp;{statistics.likes}</span>
                                        </ButtonCardAction>

                                        <ButtonCardAction
                                            title={this.props.t("Common.Feed.Actions.ButtonCommentTitle")}
                                            onClick={this.handlCommentsReview}
                                        >
                                            <IconSocialComments />
                                            <span>&nbsp;{statistics.comments}</span>
                                        </ButtonCardAction>
                                    </Grid>

                                    <Grid item className={classes.cardActions}>
                                        {this.renderRightActions()}
                                    </Grid>
                                </Grid>
                            }
                        </div>
                    </CardContent>

                </Card >
            </>
        );
    }
}

export default withTranslation()(withStyles(FeedStyleClasses)(withSnackbar(CourseAdminCard)));